var Swiper = require('swiper');

/**
 * Transforme toutes les div contenant la class owlSlider en slider
 * Les paramètres ci-dessous peuvent être passés en configuration via les attributs data de la div maitresse
 */
class Slider{
  constructor(){
    console.log('Slider initialisation');
    var sliderObj = this;
    jQuery('.swiper-container').each(function(){
      console.log($.extend({},defaults, sliderObj.sanitizeCaps($(this).data())))
      new Swiper.default(this, $.extend({},defaults, sliderObj.sanitizeCaps($(this).data())));
    })
  }

  sanitizeCaps(datas){
    var keys = ['slidesPerView', 'centeredSlides', 'centerInsufficientSlides'] // Clés à vérifier
    keys.forEach(key => {
      if(typeof datas[key.toLowerCase()] != 'undefined'){
        datas[key] = datas[key.toLowerCase()];
        delete datas[key.toLowerCase()];
      }
    });
    return datas;
  }
}

export default Slider;

/**
 * @see https://idangero.us/swiper/api/
 */
var defaults = {
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  // autoplay
  autoplay: {
    delay: 4000,
  },
  autoplayDisableOnInteraction: true,
  autoplayStopOnLast: false,
  autoHeight: false,
  effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
  },
};


// WEBPACK FOOTER //
// ./scripts/util/Slider.js